/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const DebtType = {
    Measure: 'Measure',
    Cause: 'Cause'
} as const;
export type DebtType = typeof DebtType[keyof typeof DebtType];


export function instanceOfDebtType(value: any): boolean {
    for (const key in DebtType) {
        if (Object.prototype.hasOwnProperty.call(DebtType, key)) {
            if (DebtType[key as keyof typeof DebtType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function DebtTypeFromJSON(json: any): DebtType {
    return DebtTypeFromJSONTyped(json, false);
}

export function DebtTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): DebtType {
    return json as DebtType;
}

export function DebtTypeToJSON(value?: DebtType | null): any {
    return value as any;
}

export function DebtTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): DebtType {
    return value as DebtType;
}

